// extracted by mini-css-extract-plugin
export default {"shareLinkButton":"CopyLinkButton_shareLinkButton__FhJmq"};